import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ic = _resolveComponent("ic")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "column" }, [
      _createElementVNode("div", { class: "me" }, [
        _createElementVNode("img", { src: _imports_0 }),
        _createElementVNode("h2", null, "Mateusz Słotwiński")
      ])
    ], -1)),
    _createElementVNode("button", {
      class: _normalizeClass(["hamburger", { active: _ctx.isOpen }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpen = !_ctx.isOpen)),
      "aria-label": "Menu"
    }, [
      _createVNode(_component_ic, {
        icon: _ctx.isOpen ? 'times' : 'bars'
      }, null, 8, ["icon"])
    ], 2),
    (_ctx.isOpen)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mobile-overlay",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpen = false))
        }))
      : _createCommentVNode("", true),
    _createElementVNode("nav", {
      class: _normalizeClass({ open: _ctx.isOpen })
    }, [
      _createVNode(_component_router_link, {
        to: "/",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isOpen = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('nav.blog')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/cv",
        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.isOpen = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('nav.cv')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/projects",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isOpen = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('nav.projects')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_router_link, {
        to: "/contact",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isOpen = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('nav.contact')), 1)
        ]),
        _: 1
      })
    ], 2)
  ]))
}